// src/services/config.js

// ============ App Config ============
export const APP_CONFIG = {
    name: 'CondolenceWall',
    version: process.env.APP_VERSION || '1.0.0',
    basePath: process.env.APP_BASE_PATH || '/',
}

// ============ API Config ============
export const API_CONFIG = {
    baseURL: process.env.API_URL || 'http://localhost:3001',
    timeout: 30000,
    retryCount: 1,
}

// ============ Cookie Config ============
export const COOKIE_CONFIG = {
    tokenName: 'condolencewall_token',
    daysToExpire: 7,
    path: '/',
    sameSite: 'Strict',
    secure: process.env.NODE_ENV === 'production',
}

// ============ Pagination ============
export const PAGINATION = {
    defaultPageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
}

// ============ Message Status ============
export const MESSAGE_STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
}

export const MESSAGE_STATUS_LABEL = {
    [MESSAGE_STATUS.PENDING]: { text: 'In attesa', color: 'orange' },
    [MESSAGE_STATUS.APPROVED]: { text: 'Approvato', color: 'green' },
    [MESSAGE_STATUS.REJECTED]: { text: 'Rifiutato', color: 'red' },
}

export const getMessageStatusConfig = (status) => {
    return MESSAGE_STATUS_LABEL[status] || MESSAGE_STATUS_LABEL[MESSAGE_STATUS.PENDING]
}

// ============ Agency Status ============
export const AGENCY_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    SUSPENDED: 'suspended',
}

export const AGENCY_STATUS_LABEL = {
    [AGENCY_STATUS.ACTIVE]: { text: 'Attiva', color: 'green' },
    [AGENCY_STATUS.INACTIVE]: { text: 'Inattiva', color: 'default' },
    [AGENCY_STATUS.SUSPENDED]: { text: 'Sospesa', color: 'orange' },
}

// ============ User Roles ============
export const USER_ROLES = {
    AGENCY: 'agency',
    SUPER_ADMIN: 'super_admin',
}

// ============ Storage Keys (solo per non-auth data) ============
export const STORAGE_KEYS = {
    THEME: 'theme',
    LANGUAGE: 'language',
    SIDEBAR_COLLAPSED: 'sidebar_collapsed',
    REMEMBER_ME: 'remember_me',
}

// ============ Default Boards (paesi) ============
export const DEFAULT_BOARDS = [
    { value: 'orsogna', label: 'Orsogna' },
    { value: 'filetto', label: 'Filetto' },
    { value: 'arielli', label: 'Arielli' },
    { value: 'poggiofiorito', label: 'Poggiofiorito' },
]

// ============ Query Keys per React Query ============
export const QUERY_KEYS = {
    // Public
    PUBLIC_OBITUARIES: 'publicObituaries',
    PUBLIC_OBITUARY_DETAIL: 'publicObituaryDetail',
    PUBLIC_BOARDS: 'publicBoards',

    // Agency
    AGENCY_OBITUARIES: 'agencyObituaries',
    AGENCY_MESSAGES: 'agencyMessages',
    AGENCY_BOARDS: 'agencyBoards',
    AGENCY_PROFILE: 'agencyProfile',
    AGENCY_LAYOUT_TEMPLATES: 'agencyLayoutTemplates',
    AGENCY_LAYOUT_TEMPLATE_META: 'agencyLayoutTemplateMeta',

    // Admin
    ADMIN_AGENCIES: 'adminAgencies',
    ADMIN_BOARDS: 'adminBoards',
    ADMIN_AGENCY_LAYOUT_TEMPLATES: 'adminAgencyLayoutTemplates',
}

// ============ Form validations ============
export const VALIDATION_RULES = {
    email: {
        pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: 'Inserisci un indirizzo email valido',
    },
    phone: {
        pattern: /^[0-9+\-\s()]{8,20}$/,
        message: 'Inserisci un numero di telefono valido',
    },
    password: {
        min: 6,
        message: 'La password deve avere almeno 6 caratteri',
    },
}

// ============ Date format ============
export const DATE_FORMAT = {
    display: 'DD/MM/YYYY',
    displayWithTime: 'DD/MM/YYYY HH:mm',
    api: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    apiDate: 'YYYY-MM-DD',
}

// ============ HTTP Status Codes ============
export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    SERVER_ERROR: 500,
}

// ============ File Types ============
export const FILE_TYPES = {
    IMAGE: 'image',
    PDF: 'pdf',
}

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']
export const ALLOWED_PDF_TYPES = ['application/pdf']
export const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB

// ============ Image Validation ============
export const TARGET_IMAGE_ASPECT_RATIO = 1 // 1:1 per 1080x1080
export const TARGET_IMAGE_WIDTH = 1080
export const TARGET_IMAGE_HEIGHT = 1080
export const ASPECT_RATIO_TOLERANCE = 0.1 // Tolleranza del 10%

// ============ Helper functions ============
export const isPending = (status) => status === MESSAGE_STATUS.PENDING
export const isApproved = (status) => status === MESSAGE_STATUS.APPROVED
export const isRejected = (status) => status === MESSAGE_STATUS.REJECTED
export const isActiveAgency = (status) => status === AGENCY_STATUS.ACTIVE

// Helper per file URL
export const getFileUrl = (fileId) => {
    if (!fileId) return null
    return `${API_CONFIG.baseURL}/api/public/files/${fileId}`
}